var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScribbleBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83.406,
    height: 72.733,
    viewBox: "0 0 83.406 72.733",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Scribble_19",
    d: "M385.064-637.886c-4.593,2.154-8.08,5.464-11.452,8.747-3.652,3.554-7.3,7.118-10.6,10.9a68.438,68.438,0,0,0-4.537,5.762c-1.059,1.518-2.537,3.843-.582,5.337,2.27,1.734,5.552-.487,7.461-1.6,2.354-1.375,4.564-2.908,6.773-4.436l15.653-10.835-2.473-.845a3.324,3.324,0,0,1-1.373,2.279c-.892.833-1.824,1.639-2.737,2.456-1.863,1.667-3.727,3.333-5.57,5.014-3.684,3.357-7.3,6.771-10.683,10.337-6.616,6.968-12.378,14.531-15.911,22.93a42.712,42.712,0,0,0-3.4,14.365c-.079,1.537,2.818,1.534,2.9,0,.438-8.6,4.056-16.859,9.168-24.292,5.36-7.794,12.36-14.7,19.617-21.325,2.08-1.9,4.184-3.781,6.288-5.662,1.906-1.7,4.651-3.572,4.6-6.1-.023-1.1-1.533-1.5-2.473-.845l-12.787,8.852c-2.049,1.419-4.082,2.855-6.167,4.239a35.361,35.361,0,0,1-6.2,3.545,5.8,5.8,0,0,1-.7.194c-.02,0-.04-.14-.023,0a1.758,1.758,0,0,1,.015-.422,6.579,6.579,0,0,1,1.307-2.264c1.288-1.822,2.7-3.585,4.184-5.3,2.963-3.419,6.24-6.641,9.53-9.847,3.455-3.367,6.919-6.912,11.637-9.124,1.621-.76.162-2.825-1.463-2.063Z",
    transform: "translate(-663.265 19.7) rotate(60)",
    fill: "#f9877e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScribbleBg);
export default __webpack_public_path__ + "static/media/Scribble_bg.0ed15540e1c016190ae49aa0ba1c052b.svg";
export { ForwardRef as ReactComponent };